import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** 金额一律以整数分在前后端之间传递，展示时才转成货币字符串。 */
export function formatMoney(cents: number, currency: string): string {
  const value = (cents / 100).toFixed(2);
  const symbol =
    currency === "USD"
      ? "$"
      : currency === "CNY"
        ? "¥"
        : currency === "AUD"
          ? "A$"
          : currency === "GBP"
            ? "£"
            : currency === "EUR"
              ? "€"
              : `${currency} `;
  return `${symbol}${value}`;
}
